import { render, staticRenderFns } from "./DashboardCustomerMemos.vue?vue&type=template&id=3847661e"
import script from "./DashboardCustomerMemos.vue?vue&type=script&lang=js"
export * from "./DashboardCustomerMemos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports